module.exports = global["Raven"] = require("-!/data/www/mathesio/html/webapp/node_modules/expose-loader/index.js?$!/data/www/mathesio/html/webapp/node_modules/imports-loader/index.js?global=>window,this=>window!./singleton.js");


//////////////////
// WEBPACK FOOTER
// ../~/raven-js/src/singleton.js
// module id = 350
// module chunks = 0